var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0032 8H10L13 5L16 8H14.0032C14.0032 11.3137 11.3169 14 8.0032 14C7.20619 14 6.44548 13.8446 5.74971 13.5624C5.24142 13.3563 4.7678 13.0826 4.34 12.7523L5.83185 11.3599C6.00501 11.4721 6.1874 11.5712 6.37761 11.6559C6.8743 11.8771 7.42439 12 8.0032 12C10.2123 12 12.0032 10.2091 12.0032 8ZM2 8C2 4.68629 4.68629 2 8 2C8.79701 2 9.55772 2.1554 10.2535 2.43755C10.7618 2.64367 11.2354 2.91744 11.6632 3.24768L10.1713 4.64008C9.99818 4.52794 9.8158 4.42883 9.62559 4.34412C9.1289 4.12294 8.5788 4 8 4C5.79086 4 4 5.79086 4 8H6L3 11L0 8H2Z",
    fill: "#B5BBC3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/SwapIcon.ef0703d0.svg";
export { ForwardRef as ReactComponent };